import React from "react";
import "../css/my style.css";
import "../css/my style2.css";


export default function Loginbuttonlight() {

    return(
        <button className="nav-button">Login</button>
    )
}